export default function Dialog(
    $el: JQuery,
    closeCallback?: JQueryUI.DialogEvent | null,
    options?: JQueryUI.DialogOptions
) {
    if ($el) {
        $el.removeClass('hidden');
        $el.dialog({
            closeOnEscape: true,
            height: (options && options.height) || 450,
            width: (options && options.width) || 'auto',
            modal: true,
            draggable: false,
            resizable: false,
            create: function () {
                $(this).css(
                    'maxWidth',
                    (options && options.maxWidth) || '500px'
                );
            },
            close: function (e, ui) {
                if (closeCallback) {
                    closeCallback(e, ui);
                }
            },
        });
    }
}
